export default __webpack_public_path__ + "static/media/redemption-banner.c5f6a8de.svg";